// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.14 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Montserrat, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.invisible{
  visibility: hidden;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.bottom-5{
  bottom: 1.25rem;
}
.bottom-8{
  bottom: 2rem;
}
.bottom-9{
  bottom: 2.25rem;
}
.bottom-\\[-36px\\]{
  bottom: -36px;
}
.bottom-full{
  bottom: 100%;
}
.left-0{
  left: 0px;
}
.left-1\\/2{
  left: 50%;
}
.left-2{
  left: 0.5rem;
}
.right-0{
  right: 0px;
}
.right-20{
  right: 5rem;
}
.right-\\[-10px\\]{
  right: -10px;
}
.right-\\[-30px\\]{
  right: -30px;
}
.top-0{
  top: 0px;
}
.top-1\\/2{
  top: 50%;
}
.top-16{
  top: 4rem;
}
.top-6{
  top: 1.5rem;
}
.top-\\[-10px\\]{
  top: -10px;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.row-span-1{
  grid-row: span 1 / span 1;
}
.m-0{
  margin: 0px;
}
.m-2{
  margin: 0.5rem;
}
.m-auto{
  margin: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-12{
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-8{
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-6{
  margin-left: 1.5rem;
}
.ml-7{
  margin-left: 1.75rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-20{
  margin-right: 5rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.box-border{
  box-sizing: border-box;
}
.line-clamp-1{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.flex{
  display: flex;
}
.hidden{
  display: none;
}
.h-0{
  height: 0px;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-12{
  height: 3rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-3{
  height: 0.75rem;
}
.h-32{
  height: 8rem;
}
.h-4{
  height: 1rem;
}
.h-48{
  height: 12rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-\\[10\\%\\]{
  height: 10%;
}
.h-\\[220px\\]{
  height: 220px;
}
.h-\\[34px\\]{
  height: 34px;
}
.h-\\[7\\%\\]{
  height: 7%;
}
.h-\\[75\\%\\]{
  height: 75%;
}
.h-\\[90\\%\\]{
  height: 90%;
}
.h-full{
  height: 100%;
}
.h-screen{
  height: 100vh;
}
.max-h-0{
  max-height: 0px;
}
.max-h-\\[1000px\\]{
  max-height: 1000px;
}
.max-h-\\[5000px\\]{
  max-height: 5000px;
}
.min-h-16{
  min-height: 4rem;
}
.w-0{
  width: 0px;
}
.w-1\\/2{
  width: 50%;
}
.w-1\\/3{
  width: 33.333333%;
}
.w-1\\/5{
  width: 20%;
}
.w-10{
  width: 2.5rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2\\/3{
  width: 66.666667%;
}
.w-2\\/5{
  width: 40%;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-36{
  width: 9rem;
}
.w-4{
  width: 1rem;
}
.w-5{
  width: 1.25rem;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-\\[0\\%\\]{
  width: 0%;
}
.w-\\[1\\%\\]{
  width: 1%;
}
.w-\\[10\\%\\]{
  width: 10%;
}
.w-\\[100\\%\\]{
  width: 100%;
}
.w-\\[11\\%\\]{
  width: 11%;
}
.w-\\[12\\%\\]{
  width: 12%;
}
.w-\\[13\\%\\]{
  width: 13%;
}
.w-\\[14\\%\\]{
  width: 14%;
}
.w-\\[15\\%\\]{
  width: 15%;
}
.w-\\[16\\%\\]{
  width: 16%;
}
.w-\\[17\\%\\]{
  width: 17%;
}
.w-\\[18\\%\\]{
  width: 18%;
}
.w-\\[19\\%\\]{
  width: 19%;
}
.w-\\[2\\%\\]{
  width: 2%;
}
.w-\\[20\\%\\]{
  width: 20%;
}
.w-\\[21\\%\\]{
  width: 21%;
}
.w-\\[22\\%\\]{
  width: 22%;
}
.w-\\[220px\\]{
  width: 220px;
}
.w-\\[23\\%\\]{
  width: 23%;
}
.w-\\[24\\%\\]{
  width: 24%;
}
.w-\\[25\\%\\]{
  width: 25%;
}
.w-\\[26\\%\\]{
  width: 26%;
}
.w-\\[27\\%\\]{
  width: 27%;
}
.w-\\[28\\%\\]{
  width: 28%;
}
.w-\\[29\\%\\]{
  width: 29%;
}
.w-\\[3\\%\\]{
  width: 3%;
}
.w-\\[30\\%\\]{
  width: 30%;
}
.w-\\[31\\%\\]{
  width: 31%;
}
.w-\\[32\\%\\]{
  width: 32%;
}
.w-\\[32px\\]{
  width: 32px;
}
.w-\\[33\\%\\]{
  width: 33%;
}
.w-\\[34\\%\\]{
  width: 34%;
}
.w-\\[35\\%\\]{
  width: 35%;
}
.w-\\[36\\%\\]{
  width: 36%;
}
.w-\\[37\\%\\]{
  width: 37%;
}
.w-\\[38\\%\\]{
  width: 38%;
}
.w-\\[39\\%\\]{
  width: 39%;
}
.w-\\[4\\%\\]{
  width: 4%;
}
.w-\\[40\\%\\]{
  width: 40%;
}
.w-\\[41\\%\\]{
  width: 41%;
}
.w-\\[42\\%\\]{
  width: 42%;
}
.w-\\[43\\%\\]{
  width: 43%;
}
.w-\\[44\\%\\]{
  width: 44%;
}
.w-\\[45\\%\\]{
  width: 45%;
}
.w-\\[46\\%\\]{
  width: 46%;
}
.w-\\[47\\%\\]{
  width: 47%;
}
.w-\\[48\\%\\]{
  width: 48%;
}
.w-\\[49\\%\\]{
  width: 49%;
}
.w-\\[5\\%\\]{
  width: 5%;
}
.w-\\[50\\%\\]{
  width: 50%;
}
.w-\\[51\\%\\]{
  width: 51%;
}
.w-\\[52\\%\\]{
  width: 52%;
}
.w-\\[53\\%\\]{
  width: 53%;
}
.w-\\[54\\%\\]{
  width: 54%;
}
.w-\\[55\\%\\]{
  width: 55%;
}
.w-\\[56\\%\\]{
  width: 56%;
}
.w-\\[57\\%\\]{
  width: 57%;
}
.w-\\[58\\%\\]{
  width: 58%;
}
.w-\\[59\\%\\]{
  width: 59%;
}
.w-\\[6\\%\\]{
  width: 6%;
}
.w-\\[60\\%\\]{
  width: 60%;
}
.w-\\[61\\%\\]{
  width: 61%;
}
.w-\\[62\\%\\]{
  width: 62%;
}
.w-\\[63\\%\\]{
  width: 63%;
}
.w-\\[64\\%\\]{
  width: 64%;
}
.w-\\[65\\%\\]{
  width: 65%;
}
.w-\\[66\\%\\]{
  width: 66%;
}
.w-\\[67\\%\\]{
  width: 67%;
}
.w-\\[68\\%\\]{
  width: 68%;
}
.w-\\[69\\%\\]{
  width: 69%;
}
.w-\\[7\\%\\]{
  width: 7%;
}
.w-\\[70\\%\\]{
  width: 70%;
}
.w-\\[71\\%\\]{
  width: 71%;
}
.w-\\[72\\%\\]{
  width: 72%;
}
.w-\\[73\\%\\]{
  width: 73%;
}
.w-\\[74\\%\\]{
  width: 74%;
}
.w-\\[75\\%\\]{
  width: 75%;
}
.w-\\[76\\%\\]{
  width: 76%;
}
.w-\\[77\\%\\]{
  width: 77%;
}
.w-\\[78\\%\\]{
  width: 78%;
}
.w-\\[79\\%\\]{
  width: 79%;
}
.w-\\[8\\%\\]{
  width: 8%;
}
.w-\\[80\\%\\]{
  width: 80%;
}
.w-\\[81\\%\\]{
  width: 81%;
}
.w-\\[82\\%\\]{
  width: 82%;
}
.w-\\[83\\%\\]{
  width: 83%;
}
.w-\\[84\\%\\]{
  width: 84%;
}
.w-\\[85\\%\\]{
  width: 85%;
}
.w-\\[86\\%\\]{
  width: 86%;
}
.w-\\[87\\%\\]{
  width: 87%;
}
.w-\\[88\\%\\]{
  width: 88%;
}
.w-\\[89\\%\\]{
  width: 89%;
}
.w-\\[9\\%\\]{
  width: 9%;
}
.w-\\[90\\%\\]{
  width: 90%;
}
.w-\\[91\\%\\]{
  width: 91%;
}
.w-\\[92\\%\\]{
  width: 92%;
}
.w-\\[93\\%\\]{
  width: 93%;
}
.w-\\[94\\%\\]{
  width: 94%;
}
.w-\\[95\\%\\]{
  width: 95%;
}
.w-\\[96\\%\\]{
  width: 96%;
}
.w-\\[97\\%\\]{
  width: 97%;
}
.w-\\[98\\%\\]{
  width: 98%;
}
.w-\\[99\\%\\]{
  width: 99%;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.w-min{
  width: min-content;
}
.max-w-64{
  max-width: 16rem;
}
.flex-1{
  flex: 1 1;
}
.-translate-x-36{
  --tw-translate-x: -9rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-40{
  --tw-translate-x: -10rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-48{
  --tw-translate-x: -12rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-10\\%\\]{
  --tw-translate-x: -10%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\]{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\]{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-x-\\[-100\\%\\]{
  --tw-scale-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-pointer{
  cursor: pointer;
}
.list-inside{
  list-style-position: inside;
}
.list-disc{
  list-style-type: disc;
}
.grid-flow-row{
  grid-auto-flow: row;
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-around{
  justify-content: space-around;
}
.gap-1{
  gap: 0.25rem;
}
.gap-16{
  gap: 4rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-8{
  gap: 2rem;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.overflow-y-scroll{
  overflow-y: scroll;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-b-xl{
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-l-full{
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.rounded-r-full{
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.rounded-t-xl{
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.border-2{
  border-width: 2px;
}
.border-\\[rgb\\(161_153_153\\)\\]{
  --tw-border-opacity: 1;
  border-color: rgb(161 153 153 / var(--tw-border-opacity));
}
.border-blackOverlay{
  border-color: rgba(44, 51, 56, .05);
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(44 51 56 / var(--tw-bg-opacity));
}
.bg-blackLight{
  background-color: rgba(44, 51, 56, .6);
}
.bg-blackOverlay{
  background-color: rgba(44, 51, 56, .05);
}
.bg-gray{
  --tw-bg-opacity: 1;
  background-color: rgb(156 156 156 / var(--tw-bg-opacity));
}
.bg-primary{
  --tw-bg-opacity: 1;
  background-color: rgb(105 175 204 / var(--tw-bg-opacity));
}
.bg-score1{
  --tw-bg-opacity: 1;
  background-color: rgb(34 133 68 / var(--tw-bg-opacity));
}
.bg-score2{
  --tw-bg-opacity: 1;
  background-color: rgb(159 170 19 / var(--tw-bg-opacity));
}
.bg-score3{
  --tw-bg-opacity: 1;
  background-color: rgb(198 177 20 / var(--tw-bg-opacity));
}
.bg-score4{
  --tw-bg-opacity: 1;
  background-color: rgb(241 190 51 / var(--tw-bg-opacity));
}
.bg-score5{
  --tw-bg-opacity: 1;
  background-color: rgb(189 44 41 / var(--tw-bg-opacity));
}
.bg-score6{
  --tw-bg-opacity: 1;
  background-color: rgb(164 22 35 / var(--tw-bg-opacity));
}
.bg-secondary{
  --tw-bg-opacity: 1;
  background-color: rgb(233 141 70 / var(--tw-bg-opacity));
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-score1{
  --tw-gradient-from: #228544 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 133 68 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-score3{
  --tw-gradient-from: #C6B114 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(198 177 20 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-score5{
  --tw-gradient-from: #BD2C29 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(189 44 41 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-score2{
  --tw-gradient-to: rgb(159 170 19 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #9FAA13 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-score4{
  --tw-gradient-to: rgb(241 190 51 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #F1BE33 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-score3{
  --tw-gradient-to: #C6B114 var(--tw-gradient-to-position);
}
.to-score5{
  --tw-gradient-to: #BD2C29 var(--tw-gradient-to-position);
}
.to-score6{
  --tw-gradient-to: #A41623 var(--tw-gradient-to-position);
}
.fill-none{
  fill: none;
}
.fill-primary{
  fill: #69AFCC;
}
.stroke-black{
  stroke: #2C3338;
}
.stroke-white{
  stroke: #FFFFFF;
}
.stroke-1{
  stroke-width: 1;
}
.stroke-2{
  stroke-width: 2;
}
.object-cover{
  object-fit: cover;
}
.p-1{
  padding: 0.25rem;
}
.p-12{
  padding: 3rem;
}
.p-16{
  padding: 4rem;
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-4{
  padding-top: 1rem;
}
.text-center{
  text-align: center;
}
.text-end{
  text-align: end;
}
.font-sans{
  font-family: Montserrat, sans-serif;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-light{
  font-weight: 300;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.italic{
  font-style: italic;
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(44 51 56 / var(--tw-text-opacity));
}
.text-blackLight{
  color: rgba(44, 51, 56, .6);
}
.text-blackOverlay{
  color: rgba(44, 51, 56, .05);
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-secondary{
  --tw-text-opacity: 1;
  color: rgb(233 141 70 / var(--tw-text-opacity));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.underline{
  text-decoration-line: underline;
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.opacity-50{
  opacity: 0.5;
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

:root {
  --white: #ffffff;
  --black: #2c3338;
  --black-light: rgba(44, 51, 56, 0.6);
  --white-light: rgba(255, 255, 255, 0.6);
}

@media (prefers-color-scheme: light) {
  :root {
    --background: var(--white);
    --light-text: var(--black-light);
  }
}

@media (prefers-color-scheme: dark) {
  :root {
    --background: var(--black);
    --light-text: var(--white-light);
  }
}
::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: transparent;
}

::-webkit-scrollbar {
  width: 6px;
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: var(--light-text);
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
}

#root {
  height: 100%;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.chart-container {
  cursor: pointer;
}

.hover\\:scale-105:hover{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:bg-blackLight:hover{
  background-color: rgba(44, 51, 56, .6);
}

.hover\\:bg-blackOverlay:hover{
  background-color: rgba(44, 51, 56, .05);
}

.hover\\:bg-primaryDark:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(75 113 130 / var(--tw-bg-opacity));
}

.hover\\:bg-secondary:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(233 141 70 / var(--tw-bg-opacity));
}

.hover\\:bg-secondaryDark:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(139 96 63 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:visible{
  visibility: visible;
}

.group:hover .group-hover\\:block{
  display: block;
}

.group:hover .group-hover\\:max-h-64{
  max-height: 16rem;
}

.group:hover .group-hover\\:w-10{
  width: 2.5rem;
}

.group:hover .group-hover\\:stroke-secondary{
  stroke: #E98D46;
}

.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}

@media (min-width: 640px){

  .sm\\:h-10{
    height: 2.5rem;
  }

  .sm\\:h-12{
    height: 3rem;
  }

  .sm\\:h-14{
    height: 3.5rem;
  }

  .sm\\:h-16{
    height: 4rem;
  }

  .sm\\:h-20{
    height: 5rem;
  }

  .sm\\:h-32{
    height: 8rem;
  }

  .sm\\:w-10{
    width: 2.5rem;
  }

  .sm\\:w-12{
    width: 3rem;
  }

  .sm\\:w-14{
    width: 3.5rem;
  }

  .sm\\:w-16{
    width: 4rem;
  }

  .sm\\:w-20{
    width: 5rem;
  }

  .sm\\:w-32{
    width: 8rem;
  }

  .sm\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

@media (min-width: 768px){

  .md\\:hidden{
    display: none;
  }

  .md\\:h-10{
    height: 2.5rem;
  }

  .md\\:h-32{
    height: 8rem;
  }

  .md\\:h-5{
    height: 1.25rem;
  }

  .md\\:h-6{
    height: 1.5rem;
  }

  .md\\:h-8{
    height: 2rem;
  }

  .md\\:h-\\[35vh\\]{
    height: 35vh;
  }

  .md\\:w-10{
    width: 2.5rem;
  }

  .md\\:w-56{
    width: 14rem;
  }

  .md\\:w-6{
    width: 1.5rem;
  }

  .md\\:w-96{
    width: 24rem;
  }

  .md\\:w-\\[330px\\]{
    width: 330px;
  }

  .md\\:w-\\[35vh\\]{
    width: 35vh;
  }

  .md\\:w-\\[75\\%\\]{
    width: 75%;
  }

  .md\\:w-auto{
    width: auto;
  }

  .md\\:w-full{
    width: 100%;
  }

  .md\\:max-w-72{
    max-width: 18rem;
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:items-start{
    align-items: flex-start;
  }

  .md\\:justify-start{
    justify-content: flex-start;
  }

  .md\\:gap-3{
    gap: 0.75rem;
  }

  .md\\:gap-6{
    gap: 1.5rem;
  }

  .md\\:rounded-3xl{
    border-radius: 1.5rem;
  }

  .md\\:p-12{
    padding: 3rem;
  }

  .md\\:p-6{
    padding: 1.5rem;
  }

  .md\\:p-8{
    padding: 2rem;
  }

  .md\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }

  .md\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .md\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:pl-0{
    padding-left: 0px;
  }

  .md\\:text-start{
    text-align: start;
  }

  .md\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }

  .md\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 1024px){

  .lg\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
}

@media (min-width: 1280px){

  .xl\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .xl\\:row-span-2{
    grid-row: span 2 / span 2;
  }

  .xl\\:mt-0{
    margin-top: 0px;
  }

  .xl\\:grid{
    display: grid;
  }

  .xl\\:h-10{
    height: 2.5rem;
  }

  .xl\\:h-12{
    height: 3rem;
  }

  .xl\\:h-14{
    height: 3.5rem;
  }

  .xl\\:h-24{
    height: 6rem;
  }

  .xl\\:h-6{
    height: 1.5rem;
  }

  .xl\\:h-8{
    height: 2rem;
  }

  .xl\\:h-\\[79\\%\\]{
    height: 79%;
  }

  .xl\\:h-\\[88\\%\\]{
    height: 88%;
  }

  .xl\\:h-full{
    height: 100%;
  }

  .xl\\:w-1\\/2{
    width: 50%;
  }

  .xl\\:w-10{
    width: 2.5rem;
  }

  .xl\\:w-12{
    width: 3rem;
  }

  .xl\\:w-14{
    width: 3.5rem;
  }

  .xl\\:w-2\\/3{
    width: 66.666667%;
  }

  .xl\\:w-24{
    width: 6rem;
  }

  .xl\\:w-6{
    width: 1.5rem;
  }

  .xl\\:w-8{
    width: 2rem;
  }

  .xl\\:w-full{
    width: 100%;
  }

  .xl\\:grid-flow-col{
    grid-auto-flow: column;
  }

  .xl\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-rows-2{
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }

  .xl\\:overflow-hidden{
    overflow: hidden;
  }

  .xl\\:pt-24{
    padding-top: 6rem;
  }

  .xl\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

@media (min-width: 1536px){

  .\\32xl\\:h-10{
    height: 2.5rem;
  }

  .\\32xl\\:h-12{
    height: 3rem;
  }

  .\\32xl\\:h-14{
    height: 3.5rem;
  }

  .\\32xl\\:h-16{
    height: 4rem;
  }

  .\\32xl\\:h-20{
    height: 5rem;
  }

  .\\32xl\\:h-32{
    height: 8rem;
  }

  .\\32xl\\:w-10{
    width: 2.5rem;
  }

  .\\32xl\\:w-12{
    width: 3rem;
  }

  .\\32xl\\:w-14{
    width: 3.5rem;
  }

  .\\32xl\\:w-16{
    width: 4rem;
  }

  .\\32xl\\:w-20{
    width: 5rem;
  }

  .\\32xl\\:w-32{
    width: 8rem;
  }

  .\\32xl\\:w-4\\/6{
    width: 66.666667%;
  }

  .\\32xl\\:w-auto{
    width: auto;
  }

  .\\32xl\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

@media (max-height: 850px){

  .short\\:h-9{
    height: 2.25rem;
  }

  .short\\:w-9{
    width: 2.25rem;
  }

  .short\\:w-\\[21\\%\\]{
    width: 21%;
  }

  .short\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .short\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .short\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (max-height: 600px){

  .xshort\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .xshort\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .xshort\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .xshort\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }
}

@media (prefers-color-scheme: dark){

  .dark\\:border-whiteOverlay{
    border-color: rgba(255, 255, 255, .1);
  }

  .dark\\:bg-black{
    --tw-bg-opacity: 1;
    background-color: rgb(44 51 56 / var(--tw-bg-opacity));
  }

  .dark\\:bg-white{
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  }

  .dark\\:bg-whiteLight{
    background-color: rgba(255, 255, 255, .6);
  }

  .dark\\:bg-whiteOverlay{
    background-color: rgba(255, 255, 255, .1);
  }

  .dark\\:stroke-white{
    stroke: #FFFFFF;
  }

  .dark\\:text-black{
    --tw-text-opacity: 1;
    color: rgb(44 51 56 / var(--tw-text-opacity));
  }

  .dark\\:text-white{
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }

  .dark\\:text-whiteLight{
    color: rgba(255, 255, 255, .6);
  }

  .dark\\:text-whiteOverlay{
    color: rgba(255, 255, 255, .1);
  }

  .dark\\:hover\\:bg-whiteLight:hover{
    background-color: rgba(255, 255, 255, .6);
  }

  .dark\\:hover\\:bg-whiteOverlay:hover{
    background-color: rgba(255, 255, 255, .1);
  }

  .hover\\:dark\\:bg-whiteOverlay:hover{
    background-color: rgba(255, 255, 255, .1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B,sBAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B;AAA0B;;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B,sBAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B;AAA0B;;AAA1B;;CAA0B;;AAA1B;;;CAA0B;;AAA1B;;;EAAA,sBAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,mBAA0B,EAA1B,MAA0B;EAA1B,0BAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;EAAA,gBAA0B;AAAA;;AAA1B;;;;;;;;CAA0B;;AAA1B;;EAAA,gBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B,EAA1B,MAA0B;EAA1B,WAA0B,EAA1B,MAA0B;EAA1B,mCAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,wCAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,yCAA0B;UAA1B,iCAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;;;;;EAAA,kBAA0B;EAA1B,oBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,cAA0B;EAA1B,wBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,mBAA0B;AAAA;;AAA1B;;;;;CAA0B;;AAA1B;;;;EAAA,+GAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,cAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,cAA0B;EAA1B,cAA0B;EAA1B,kBAA0B;EAA1B,wBAA0B;AAAA;;AAA1B;EAAA,eAA0B;AAAA;;AAA1B;EAAA,WAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;EAA1B,yBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;;;;;EAAA,oBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B;EAA1B,gCAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,uBAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,SAA0B,EAA1B,MAA0B;EAA1B,UAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,oBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;;;;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,aAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,gBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,wBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,YAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,6BAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,wBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,aAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,kBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;;;;;;;;;;;;EAAA,SAA0B;AAAA;;AAA1B;EAAA,SAA0B;EAA1B,UAA0B;AAAA;;AAA1B;EAAA,UAA0B;AAAA;;AAA1B;;;EAAA,gBAA0B;EAA1B,SAA0B;EAA1B,UAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,UAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,gBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;;EAAA,UAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,eAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,eAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;;;;;;;;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,eAA0B;EAA1B,YAA0B;AAAA;;AAA1B,wEAA0B;;AAA1B;EAAA,aAA0B;AAAA;AAE1B;EAAA,kBAA+B;EAA/B,UAA+B;EAA/B,WAA+B;EAA/B,UAA+B;EAA/B,YAA+B;EAA/B,gBAA+B;EAA/B,sBAA+B;EAA/B,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;;EAAA;IAAA;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,sDAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,eAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,+EAA+B;EAA/B,mGAA+B;EAA/B;AAA+B;AAA/B;EAAA,gFAA+B;EAA/B,oGAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;;AAE/B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE;IACE,0BAA0B;IAC1B,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,gCAAgC;EAClC;AACF;AACA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;aACW;AACb;;AAEA;EACE,eAAe;AACjB;;AA/DA;EAAA,kBAgEA;EAhEA,kBAgEA;EAhEA;AAgEA;;AAhEA;EAAA;AAgEA;;AAhEA;EAAA;AAgEA;;AAhEA;EAAA,kBAgEA;EAhEA;AAgEA;;AAhEA;EAAA,kBAgEA;EAhEA;AAgEA;;AAhEA;EAAA,kBAgEA;EAhEA;AAgEA;;AAhEA;EAAA;AAgEA;;AAhEA;EAAA;AAgEA;;AAhEA;EAAA;AAgEA;;AAhEA;EAAA;AAgEA;;AAhEA;EAAA;AAgEA;;AAhEA;EAAA;AAgEA;;AAhEA;;EAAA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA,mBAgEA;IAhEA;EAgEA;;EAhEA;IAAA,eAgEA;IAhEA;EAgEA;AAAA;;AAhEA;;EAAA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA,iBAgEA;IAhEA;EAgEA;;EAhEA;IAAA,oBAgEA;IAhEA;EAgEA;;EAhEA;IAAA,oBAgEA;IAhEA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA,iBAgEA;IAhEA;EAgEA;;EAhEA;IAAA,mBAgEA;IAhEA;EAgEA;;EAhEA;IAAA,kBAgEA;IAhEA;EAgEA;;EAhEA;IAAA,eAgEA;IAhEA;EAgEA;;EAhEA;IAAA,mBAgEA;IAhEA;EAgEA;;EAhEA;IAAA,mBAgEA;IAhEA;EAgEA;;EAhEA;IAAA,kBAgEA;IAhEA;EAgEA;AAAA;;AAhEA;;EAAA;IAAA,iBAgEA;IAhEA;EAgEA;AAAA;;AAhEA;;EAAA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA,mBAgEA;IAhEA;EAgEA;AAAA;;AAhEA;;EAAA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA,eAgEA;IAhEA;EAgEA;AAAA;;AAhEA;;EAAA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA,iBAgEA;IAhEA;EAgEA;;EAhEA;IAAA,mBAgEA;IAhEA;EAgEA;;EAhEA;IAAA,kBAgEA;IAhEA;EAgEA;AAAA;;AAhEA;;EAAA;IAAA,eAgEA;IAhEA;EAgEA;;EAhEA;IAAA,mBAgEA;IAhEA;EAgEA;;EAhEA;IAAA,mBAgEA;IAhEA;EAgEA;;EAhEA;IAAA,kBAgEA;IAhEA;EAgEA;AAAA;;AAhEA;;EAAA;IAAA;EAgEA;;EAhEA;IAAA,kBAgEA;IAhEA;EAgEA;;EAhEA;IAAA,kBAgEA;IAhEA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA,oBAgEA;IAhEA;EAgEA;;EAhEA;IAAA,oBAgEA;IAhEA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;;EAhEA;IAAA;EAgEA;AAAA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');\n\n@import 'tailwindcss/base';\n@import 'tailwindcss/components';\n@import 'tailwindcss/utilities';\n\n:root {\n  --white: #ffffff;\n  --black: #2c3338;\n  --black-light: rgba(44, 51, 56, 0.6);\n  --white-light: rgba(255, 255, 255, 0.6);\n}\n\n@media (prefers-color-scheme: light) {\n  :root {\n    --background: var(--white);\n    --light-text: var(--black-light);\n  }\n}\n\n@media (prefers-color-scheme: dark) {\n  :root {\n    --background: var(--black);\n    --light-text: var(--white-light);\n  }\n}\n::-webkit-scrollbar-track {\n  border-radius: 10px;\n  background-color: transparent;\n}\n\n::-webkit-scrollbar {\n  width: 6px;\n  background-color: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: var(--light-text);\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  height: 100vh;\n}\n\n#root {\n  height: 100%;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.chart-container {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
